import styled from "styled-components";
import { dark, sidebar, secondary, ligthGray, white } from "styles/theme";
import { Report } from '@mui/icons-material';
import { Box, Button, Drawer } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { Scroll } from "styles/GlobalCss";
import { thirdly } from "styles/theme";
import { boxSizing, height } from "@mui/system";

export const SelectRoleStyles = muiStyled(Box)(({ selected }) => ({
    color: "white",
    display: "flex",
    columnGap: 10,
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "0.875rem",
    padding: "10px 10px",
    borderBottom: "2px solid #416783",
    cursor: "pointer",
    ":hover": {
        opacity: 0.7
    },
    '.role-details': {
        display: "flex",
        columnGap: 10,
        alignItems: "center",
    },
    '.role-icon': {
        width: 25,
        height: 25
    }
}));

export const SystemBtnsStyles = muiStyled(Box)(({ selected }) => ({
    display: "flex",
    columnGap: 15,
    padding: "15px 15px 0px 15px",
    '.MuiButtonBase-root.MuiIconButton-root:hover:hover': {

    },
    '.selected': {
        background: `${thirdly} !important`,
        outline: `2px solid ${thirdly}`,
        outlineOffset: 4
    },
    '.unselected': {
        background: "#CAD3DF !important",
    }
}));

export const BrokenDisplayStyles = muiStyled(Box)(({ selected }) => ({
    display: "flex",
    color: "white",
    alignItems: "center",
    justifyContent: "space-between",
    '.chanage-broken-value': {
        display: "flex",
        alignItems: "center",
        position: "relative",
        bottom: 2
    }
}));

export const FooterStyles = muiStyled(Box)(({ selected }) => ({
    display: "flex",
    width: "100%",
    height: 83,
    alignItems: "center",
    flexDirection: "column",
    flexShrink: 0,
    '.add-comment-btn': {
        position: "relative",
        bottom: 18,
        width: "100%",
        boxSizing: "border-box",
        padding: "0px 12px",
        '.MuiSvgIcon-root': {
            width: 16,
            height: 16
        },
        '.MuiButton-root': {
            justifyContent: "start",
            columnGap: "10px !important"
        }
    }
}));

const WrapSubItems = styled.div`
// position: relative;
// right: 10px;
// width: calc(100% - 10px);
`

const UserName = styled.div`
font-weight: 600;
`

const UserEmail = styled.div`
font-size: 16px;
color: #B6B9C7;
font-weight: 400;
`

const UserDetails = styled.div`
color:${white};
padding: 10px 0px 10px 0px;
font-size:16px;
`

const WrapSideBar = styled.div`
position: absolute;
right: 0;
z-index: 1;
height:100%;
background:${dark};
width:${sidebar}px;
// padding:15px;
display: flex;
flex-direction: column;
row-gap: 15px;

${Scroll}
`

const ItemButton = styled(Button)`
display:flex;
column-gap: 10px;
display: flex !important;
justify-content: flex-start !important;


${props => props.disabled && `
color:${ligthGray} !important;
opacity:0.5 !important;

${props.selected && `
background:${secondary} !important;
`}

`}
`

const Header = styled.div`
padding:15px;
height:100px;
flex-shrink:0;
`

const Content = styled.div`
display: flex;
flex-direction: column;
margin-top: 10px;
flex-grow:1;
overflow:auto;
${Scroll};
`

const WReportIcon = styled(Report)`
color:white;
width:30px;
height:30px;
`

const SideBarStyles = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    '.menu-icon .MuiButtonBase-root.MuiIconButton-root': {
        color: theme.palette.text.primary, // השתמש בצבע מהנושא
        zIndex: 10,
        left: 15,
        position: "absolute",
        padding: 10,
        top: 10
    },
}));

const DrawerStyles = muiStyled(Drawer)(({ theme, $systemUI, len, index }) => ({
    '& .MuiPaper-root.MuiDrawer-paper': {
        background: dark,
        width: 230,
    }
}));


export { DrawerStyles, SideBarStyles, UserEmail, UserName, ItemButton, UserDetails, WrapSubItems, Content, WrapSideBar, Header, WReportIcon }